import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { patientActions } from "../../core/actions";
import { insuranceActions } from "../../core/actions";
import { Alert } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import Button from "@mui/material/Button";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  FormControl,
  Select,
  Radio,
  RadioGroup,
  MenuItem,
} from "@mui/material";
import { FormGroup, Checkbox } from "@mui/material";

import Components from "..";
import { list } from "suneditor/src/plugins";
import { tr } from "date-fns/locale";

function InsuranceProcedureInput(props) {
  const dispatch = useDispatch();
  const [isReadonly, setIsReadonly] = useState(false);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const { insurance } = "insurance";
  const [selectedRadio, setSelectedRadio] = useState();
  const [insuranceList, setInsuranceList] = useState();
  const [tpa, setTpa] = useState([]);
  const [companyname, setCompanyName] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [invoiceError, setInvoiceError] = useState(false);

  const [insuranceDetails, setInsuranceDetails] = useState({
    patientId: props.patientInfo.patientId,
    visitId: props.patientInfo.visitId,
    type: props.insurancetype,
    policyNum: "",
    iName: "",
    iOrg: "",
    tpa: "",
    description: "",
    uploadId: "",
    status: "",
    claimNum: "",
    amount: "",
    invoiceNum: "",
    cardNumber: "",
    expiryDate: "",
    comment: "",
  });

  const [formErrors, setFormErrors] = useState({
    policyNum: "",
    iName: "",
    iOrg: "",
    amount: "",
    status: "",
    claimNum: "",
    invoiceNum: "",
    cardNumber: "",
    expiryDate: "",
    comment: "",
    tpa: "",
  });

  useEffect(() => {
    console.log("insurance props:", props);
    getInsMaster();
    getTtpMaster();
    handleInvoiceList();
    if (props.mode == "edit") {
      setFormDetails();
    }
  }, []);

  const getInsMaster = () => {
    dispatch(
      insuranceActions.getInsuranceMaster((resCb) => {
        if (resCb) {
          console.log("getInsuranceMaster", resCb.masterinsurancelist);

          console.log("response from api : ", resCb);
          let company = [];
          let companylist = resCb.masterinsurancelist;
          if (companylist && companylist != null) {
            for (let comp of companylist) {
              console.log("comp", comp.companyName);
              company.push(comp);
            }
            setCompanyName(company);
          }
        }
      })
    );
  };

  const getTtpMaster = () => {
    dispatch(
      insuranceActions.gettpaMaster((resCb) => {
        if (resCb) {
          console.log("getTpaMaster", resCb.tpaMasterList);
          console.log("response from api : ", resCb);
          let tpainsurance = [];
          let tpalist = resCb.tpaMasterList;
          if (tpalist && tpalist != null) {
            for (let tpa of tpalist) {
              tpainsurance.push(tpa);
              // insuranceDetails['tpa'] = tpa.id;
            }
            setTpa(tpainsurance);
          }
        }
      })
    );
  };

  const handleInvoiceList = () => {
    if (!props.insurancelists || !Array.isArray(props.insurancelists)) {
      console.warn("insurancelists is undefined or not an array");
      setInvoiceList([]);
      return;
    }

    let list = props.insurancelists.filter(
      (insurance) =>
        insurance.type === "InvoiceGen" && insurance.claimStatus !== "approved"
    );
    console.log("list", list);

    setInvoiceList(list);
  };

  const setFormDetails = () => {
    let insurancelistlocal = props.insurancelists;
    console.log("insurancelistlocal", insurancelistlocal);

    if (insurancelistlocal && props.insurancetype === "Basic") {
      for (let insure of insurancelistlocal) {
        if (insure.type === "Basic") {
          insuranceDetails["policyNum"] = insure.policyNum;
          insuranceDetails["iName"] = insure.iName;
          insuranceDetails["cardNumber"] = insure.cardNumber;
          insuranceDetails["expiryDate"] = insure.expiryDate;
          insuranceDetails["iOrg"] = insure.iOrg;
          insuranceDetails["tpa"] = insure.tpa;
          insuranceDetails["description"] = insure.description;
          insuranceDetails["id"] = insure.id;
          insuranceDetails["udt"] = "";
        }
      }
      setInsuranceDetails({ ...insuranceDetails });
      console.log("insurance after set", insuranceDetails);
    }

    if (props.insurancelists && props.insurancetype === "Claim Request") {
      for (let insure of props.insurancelists) {
        if (insure.type === "Claim Request") {
          setIsReadonly(true);
          insuranceDetails["id"] = insure.id;
          insuranceDetails["description"] = insure.description;
          insuranceDetails["invoiceNum"] = insure.invoiceNum;
          insuranceDetails["amount"] = insure.amount;

          // Sync invoiceNum to checkbox selection
          if (insure.invoiceNum) {
            const invoiceNums = insure.invoiceNum
              .split(",")
              .map((inv) => inv.trim());
            const invoiceDates = insure.invoiceDatedesc
              ? insure.invoiceDatedesc.split(",").map((date) => date.trim())
              : [];

            const selected = invoiceNums.map((inv, index) => ({
              invoiceNum: inv,
              invoiceDate: invoiceDates[index] || null,
            }));

            setSelectedInvoices(selected);
            insuranceDetails["invoiceDatedesc"] = insure.invoiceDatedesc;
          } else {
            setSelectedInvoices([]);
          }
        }
      }
      setInsuranceDetails({ ...insuranceDetails });
    }

    if (props.insurancelists && props.insurancetype === "Pre Auth Request") {
      for (let insure of props.insurancelists) {
        if (insure.type === "Pre Auth Request") {
          setIsReadonly(true);
          insuranceDetails["id"] = insure.id;
          insuranceDetails["description"] = insure.description;
          insuranceDetails["amount"] = insure.amount;
          insuranceDetails["claimNum"] = insure.claimNum;
        }
      }
      setInsuranceDetails({ ...insuranceDetails });
    }

    if (props.insurancelists && props.insurancetype === "Pre Auth Response") {
      for (let insure of props.insurancelists) {
        if (insure.type === "Pre Auth Response") {
          setIsReadonly(true);
          insuranceDetails["id"] = insure.id;
          insuranceDetails["description"] = insure.description;
          insuranceDetails["amount"] = insure.amount;
          insuranceDetails["claimNum"] = insure.claimNum;
          insuranceDetails["status"] = insure.status;
          insuranceDetails["comment"] = insure.comment;
          setSelectedRadio(insure.status);
        }
      }
      setInsuranceDetails({ ...insuranceDetails });
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("finalData", insuranceDetails);
    Object.keys(insuranceDetails).forEach((key) => {
      validateField(key, insuranceDetails[key]);
    });
    if (
      props.insurancetype === "Claim Request" &&
      selectedInvoices.length === 0
    ) {
      setInvoiceError(true);
      return;
    } else {
      setInvoiceError(false);
    }
    validateForm(event);
  };

  const validateField = (fieldName, value) => {
    let fieldValidationErrors = formErrors;
    let basicInfo = insuranceDetails;
    console.log("Basic Info", basicInfo);
    console.log("value:", value);
    switch (fieldName) {
      case "policyNum":
        if (props.insurancetype === "Basic") {
          fieldValidationErrors.policyNum =
            value.length > 0 ? "" : "Please Enter Policy Number";
          basicInfo.policyNum = value !== "" ? value : "";
        }

        break;
      case "iName":
        if (props.insurancetype === "Basic") {
          fieldValidationErrors.iName =
            value.length > 0 ? "" : "Please Enter Insurer Name";
          basicInfo.iName = value !== "" ? value : "";
        }
        break;
      case "cardNumber":
        if (props.insurancetype === "Basic") {
          fieldValidationErrors.cardNumber =
            value.length > 0 ? "" : "Please Enter Card Number";
          basicInfo.cardNumber = value !== "" ? value : "";
        }
        break;
      case "expiryDate":
        if (props.insurancetype === "Basic") {
          fieldValidationErrors.expiryDate =
            value.length > 0 ? "" : "Please Enter Expiry Date";
          basicInfo.expiryDate = value !== "" ? value : "";
        }
        break;
      case "iOrg":
        if (props.insurancetype === "Basic") {
          fieldValidationErrors.iOrg = value
            ? ""
            : "Please select Insurance Organization";
          basicInfo.iOrg = value !== "" ? value : "";
        }
        break;
      // case "tpa":
      //   if (props.insurancetype === "Basic") {
      //     fieldValidationErrors.tpa = value
      //       ? ""
      //       : "Please select Insurance Claim";
      //     basicInfo.tpa = value !== "" ? value : "";
      //   }
      //   break;
      case "amount":
        if (
          props.insurancetype === "Pre Auth Request" ||
          props.insurancetype === "Pre Auth Response" ||
          props.insurancetype === "Claim Request" ||
          props.insurancetype === "Claim Approval"
        ) {
          fieldValidationErrors.amount =
            value != "" > 0 ? "" : "Please Enter Amount";
          basicInfo.amount = value !== "" ? value : "";
        }

        break;

      case "claimNum":
        if (props.insurancetype === "Pre Auth Response") {
          fieldValidationErrors.claimNum =
            value.length > 0 ? "" : "Please Enter Claim Number";
          basicInfo.claimNum = value !== "" ? value : "";
        }
        break;

      case "status":
        if (
          props.insurancetype === "Pre Auth Response" ||
          props.insurancetype === "Claim Approval"
        ) {
          fieldValidationErrors.status =
            value.length > 0 ? "" : "Please Select Status";
          basicInfo.status = value !== "" ? value : "";
        }
        break;

      case "comment":
        if (
          (props.insurancetype === "Pre Auth Response" ||
            props.insurancetype === "Claim Approval") &&
          insuranceDetails.status === "deny"
        ) {
          fieldValidationErrors.comment =
            value.length > 0 ? "" : "Please Enter comment";
          basicInfo.comment = value !== "" ? value : "";
        }
        break;
      case "invoiceNum":
        if (props.insurancetype === "Claim Request") {
          fieldValidationErrors.invoiceNum =
            value.length > 0 ? "" : "Please Enter Invoice Number";
          basicInfo.invoiceNum = value !== "" ? value : "";
        }
        break;
      default:
        break;
    }
    console.log("fieldValidationErrors:", fieldValidationErrors);
    setFormErrors({ ...fieldValidationErrors });
  };

  const validateForm = (event) => {
    event.preventDefault();
    let formValid =
      formErrors.policyNum === "" &&
      formErrors.iName === "" &&
      formErrors.cardNumber === "" &&
      formErrors.expiryDate === "" &&
      formErrors.status === "" &&
      formErrors.claimNum === "" &&
      formErrors.amount === "" &&
      formErrors.comment === "" &&
      formErrors.iOrg === "" &&
      formErrors.tpa === "";
    console.log("formValid:", formValid);
    if (formValid) {
      if (insuranceDetails && insuranceDetails["id"]) {
        let data = [];
        var ServerResVal = ServerRes;
        data.push(insuranceDetails);
        console.log("Data", data);
        let check = true;
        if (insuranceDetails.type == "Claim Request") {
          check = addInsurancedata();
        }
        dispatch(
          patientActions.updateInsuranceProcedure(data, (resCb) => {
            console.log("insuranceDetails:", insuranceDetails);
            if (resCb) {
              if (resCb.successMessages) {
                props.onModalClose({
                  success: "Insurance details updated succesfully",
                });
                // ServerResVal.success = "Insurance details saved succesfully"
              } else {
                // ServerResVal.error = "Failed to save Insurance details";
                props.onModalClose({
                  error: "Failed to update Insurance details",
                });
              }

              setServerRes({ ...ServerResVal });
              console.log("resCb");
              //  props.onModalClose()
              insuranceDetails.policyNum = "";
              insuranceDetails.iName = "";
              insuranceDetails.iOrg = "";
              insuranceDetails.tpa = "";
              insuranceDetails.description = "";
              insuranceDetails.uploadId = "";
              insuranceDetails.status = "";
              insuranceDetails.claimNum = "";
              insuranceDetails.amount = "";
              insuranceDetails.invoiceNum = "";
            }
          })
        );
      } else {
        let check = true;
        if (
          insuranceDetails.type == "Claim Approval" ||
          insuranceDetails.type == "Claim Request"
        ) {
          check = addInsurancedata();
        }
        if (check) {
          dispatch(
            patientActions.addInsuranceProcedure(insuranceDetails, (resCb) => {
              console.log("insuranceDetails:", insuranceDetails);
              var ServerResVal = ServerRes;
              if (resCb) {
                if (resCb.successMessages) {
                  props.onModalClose({
                    success: "Insurance details saved succesfully",
                  });
                  // ServerResVal.success = "Insurance details saved succesfully"
                } else {
                  // ServerResVal.error = "Failed to save Insurance details";
                  props.onModalClose({
                    error: "Failed to save Insurance details",
                  });
                }

                setServerRes({ ...ServerResVal });
                console.log("resCb");
                //   props.onModalClose()
                insuranceDetails.policyNum = "";
                insuranceDetails.iName = "";
                insuranceDetails.cardNumber = "";
                insuranceDetails.expiryDate = "";
                insuranceDetails.iOrg = "";
                insuranceDetails.tpa = "";
                insuranceDetails.description = "";
                insuranceDetails.uploadId = "";
                insuranceDetails.status = "";
                insuranceDetails.claimNum = "";
                insuranceDetails.amount = "";
                insuranceDetails.invoiceNum = "";
              }
            })
          );
        } else {
          // props.onModalClose();
        }
      }
    } else {
      setTimeout(() => {
        var errors = document.querySelectorAll(".is-invalid");
        console.log("errors:", errors);
        if (errors.length > 0) {
          errors[0].focus();
        }
      }, 500);
    }
  };

  const addInsurancedata = (insurance) => {
    var ServerResVal = { ...ServerRes };

    // If current insurance type is "Claim Request", set claimNum and return
    if (insuranceDetails?.type === "Claim Request") {
      for (let insure of props.insurancelists) {
        if (
          insure?.type === "Pre Auth Response" &&
          insure.status === "approve" &&
          insure?.claimNum
        ) {
          insuranceDetails["claimNum"] = insure.claimNum;
        }
      }
      console.log("insuranceDetails (Claim Request):", insuranceDetails);
      return true;
    }

    let hasClaimRequest = false;
    let hasPreAuthResponse = false;
    let hasBasicInsurance = false;

    for (let insure of props.insurancelists) {
      if (insure?.type === "Pre Auth Response" && insure?.claimNum) {
        insuranceDetails["claimNum"] = insure.claimNum;
        hasPreAuthResponse = true;
      }

      if (insure?.type === "Claim Request" && insure?.invoiceNum) {
        if (!insuranceDetails["invoiceNum"]) {
          insuranceDetails["invoiceNum"] = insure.invoiceNum;
        }
        hasClaimRequest = true;
      }

      if (insure.type == "Basic" && insure.iOrg) {
        hasBasicInsurance = true;
        companyname.forEach((options) => {
          if (options.id == insure.iOrg) {
            console.log("options", options);
            insuranceDetails["insurance"] = options.companyName;
          }
        });
      }
    }

    let errorMessage = "";

    if (!hasClaimRequest) {
      errorMessage =
        "Please select Claim Request and fill the required details";
    } else if (!hasPreAuthResponse) {
      errorMessage =
        "Please select Pre Auth Response with a valid claim number";
    } else if (!hasBasicInsurance) {
      errorMessage = "Please select Basic insurance with a valid company";
    }

    if (errorMessage) {
      ServerRes.error = errorMessage;
      console.log("Alert closed", ServerRes);
      setTimeout(() => {
        closeAlert();
        console.log("Alert closed", ServerRes);
        props.onModalClose();
      }, 3000);
    } else {
      // Finalize insuranceDetails
      insuranceDetails["customerId"] = props.patientInfo.erpCustId;
      console.log("insuranceDetails:", insuranceDetails);
      return true;
    }
  };

  const handleInputChange = (name, value) => {
    formErrors[name] = "";
    console.log("changed", value);

    let insurancelocal = insuranceDetails;
    insurancelocal[name] = value;

    setInsuranceDetails({ ...insuranceDetails, [name]: value });
    console.log("polynumber:", insuranceDetails);
  };

  const closeModal = (e) => {
    props.onModalClose();
  };

  const addfile = (event) => {
    console.log("images:", event.target.files);
    let images = [{}];
  };

  const onValueChange = (value) => {
    setSelectedRadio(value);
    console.log("selectedOptionRadio", value);
    insuranceDetails["status"] = value;
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const closeAttachment = (e) => {
    closeModal();
  };

  const handleInvoiceCheckboxChange = (checked, invoiceObj) => {
    console.log("Checkbox changed:", checked, invoiceObj);

    let updated;

    if (checked) {
      updated = [...selectedInvoices, invoiceObj];
    } else {
      updated = selectedInvoices.filter(
        (inv) => inv.invoiceNum !== invoiceObj.invoiceNum
      );
    }

    setSelectedInvoices(updated);

    // Combine and set values
    const invoiceNums = updated.map((inv) => inv.invoiceNum).join(",");
    const invoiceDates = updated.map((inv) => inv.invoiceDate).join(",");

    handleInputChange("invoiceNum", invoiceNums);
    handleInputChange("invoiceDatedesc", invoiceDates);
    setInvoiceError(false);

    // Calculate updated amount
    const toggledInvoice = invoiceList.find(
      (invoice) => invoice.invoiceNum === invoiceObj.invoiceNum
    );
    const amount = toggledInvoice ? Number(toggledInvoice.amount) : 0;

    const currentAmount = insuranceDetails.amount
      ? Number(insuranceDetails.amount)
      : 0;

    const updatedAmount = checked
      ? currentAmount + amount
      : currentAmount - amount;

    handleInputChange("amount", updatedAmount);
  };

  return (
    <>
      {/* <Modal className='insurance-procedure bg-none' id="insurance-modal" open={true}  toggle={closeModal}> */}
      <Dialog
        className="insurance-procedure error-strip bg-none"
        id="insurance-modal"
        open={true} // Assuming the modal is always open
        onClose={closeModal}
        disableEnforceFocus
      >
        <DialogTitle className="py-2 m-2">
          {props.insurancetype}
          {props.insurancetype && props.insurancetype != "Upload Document" ? (
            <IconButton
              className="close-model"
              aria-label="close"
              onClick={(e) => {
                closeModal(e);
              }}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : (
            ""
          )}
        </DialogTitle>
        <div className="px-3 modal-subsection">
          {ServerRes.success && (
            <Alert severity="success" className="alert-div">
              {ServerRes.success}{" "}
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={(event) => closeAlert(event)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </Alert>
          )}
          {ServerRes.error && (
            <Alert
              severity="error"
              className="error-strip  alert-div alert-div-error"
            >
              {ServerRes.error}{" "}
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={(event) => closeAlert(event)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </Alert>
          )}

          <div className="d-flex flex-column">
            <div className="d-flex">
              <div className="w-50" style={{ fontSize: "13px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr auto", // name takes full space, phone stays fixed
                    alignItems: "center",
                    padding: "0 16px",
                    gap: "16px",
                    whiteSpace: "nowrap", // prevent wrapping
                  }}
                >
                  {/* Patient Name */}
                  <span
                    style={{
                      textTransform: "capitalize",
                      overflow: "visible", // ensures full name shows
                    }}
                  >
                    {props.patientInfo.fname} {props.patientInfo.lname}
                  </span>

                  {/* Phone Number */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i
                      className="material-icons p-icon"
                      style={{ fontSize: "16px" }}
                    >
                      phone
                    </i>
                    <span className="p-data">{props.patientInfo.phno}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DialogContent
          id="appointment-body"
          className="py-1 justify-content-between h-100 mx-2"
        >
          <div className="position-relative">
            <div className="bg-none border-0 h-100">
              <Grid container className="h-100">
                <Grid item xs={12}>
                  <form className="mt-2">
                    <Grid container spacing={2}>
                      <>
                        {props.insurancetype &&
                        props.insurancetype === "Basic" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="policynumber" className="basicInf">
                              Policy Number{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <TextField
                              id="polyname"
                              value={insuranceDetails.policyNum}
                              placeholder="Policy Num"
                              required
                              autoComplete="off"
                              onChange={(event) => {
                                handleInputChange(
                                  "policyNum",
                                  event.target.value
                                );
                              }}
                              error={formErrors.policyNum !== ""}
                              helperText={
                                <span style={{ color: "#EC4147" }}>
                                  {formErrors.policyNum}
                                </span>
                              }
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {props.insurancetype &&
                        props.insurancetype === "Basic" ? (
                          <Grid item md={6} className="form-group">
                            <label
                              htmlFor="insurance name"
                              className="basicInf"
                            >
                              Insurer Name{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <TextField
                              id="iname"
                              value={insuranceDetails.iName}
                              placeholder="Insurer name"
                              onChange={(event) => {
                                handleInputChange("iName", event.target.value);
                              }}
                              error={formErrors.iName !== ""}
                              helperText={
                                <span style={{ color: "#EC4147" }}>
                                  {formErrors.iName}
                                </span>
                              }
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )}
                        {props.insurancetype &&
                        props.insurancetype === "Basic" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="iorg">Insurance Organization</label>

                            <FormControl fullWidth class="insuranceDropdown">
                              <Select
                                displayEmpty // labelId="iorg-label"
                                value={insuranceDetails.iOrg}
                                name="selectType"
                                onChange={(event) => {
                                  handleInputChange("iOrg", event.target.value);
                                }}
                                variant="outlined"
                                error={formErrors.iName !== ""}
                                helperText={
                                  <span style={{ color: "#EC4147" }}>
                                    {formErrors.iOrg}
                                  </span>
                                }
                              >
                                <MenuItem value="">Select Type</MenuItem>
                                {companyname.map((options, index) => (
                                  <MenuItem key={index} value={options.id}>
                                    {options.companyName}
                                  </MenuItem>
                                ))}
                              </Select>
                              {formErrors.iOrg && (
                                <span
                                  style={{
                                    color: "#EC4147",
                                    fontSize: "12px",
                                    marginTop: "4px",
                                  }}
                                >
                                  {formErrors.iOrg}
                                </span>
                              )}
                            </FormControl>
                          </Grid>
                        ) : (
                          ""
                        )}

                        {/* {props.insurancetype &&
                        props.insurancetype === "Basic" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="insurane claim">
                              Insurance Claim
                            </label>
                            <FormControl fullWidth class="insuranceDropdown">
                              <Select
                                displayEmpty
                                value={insuranceDetails.tpa}
                                name="selectType"
                                className="w-100"
                                onChange={(event) => {
                                  handleInputChange("tpa", event.target.value);
                                }}
                              >
                                <MenuItem value="">Select Type</MenuItem>
                                {tpa.map((options, index) => (
                                  <MenuItem key={index} value={options.id}>
                                    {options.companyName}
                                  </MenuItem>
                                ))}
                              </Select>
                              {formErrors.tpa && (
                                <span
                                  style={{
                                    color: "#EC4147",
                                    fontSize: "12px",
                                    marginTop: "4px",
                                  }}
                                >
                                  {formErrors.tpa}
                                </span>
                              )}
                            </FormControl>
                          </Grid>
                        ) : (
                          ""
                        )} */}

                        {props.insurancetype &&
                        props.insurancetype === "Basic" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="card number" className="basicInf">
                              Card Number <span className="text-danger">*</span>
                            </label>
                            <TextField
                              id="iname"
                              value={insuranceDetails.cardNumber}
                              placeholder="Card Number"
                              onChange={(event) => {
                                handleInputChange(
                                  "cardNumber",
                                  event.target.value
                                );
                              }}
                              error={formErrors.cardNumber !== ""}
                              helperText={
                                <span style={{ color: "#EC4147" }}>
                                  {formErrors.cardNumber}
                                </span>
                              }
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {props.insurancetype &&
                        props.insurancetype === "Basic" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="expiry date" className="basicInf">
                              Expiry Date <span className="text-danger">*</span>
                            </label>
                            <TextField
                              id="expiryDate"
                              type="date"
                              value={insuranceDetails.expiryDate || ""} // Ensure it's not undefined
                              onChange={(event) =>
                                handleInputChange(
                                  "expiryDate",
                                  event.target.value
                                )
                              }
                              error={formErrors.expiryDate !== ""}
                              helperText={
                                <span style={{ color: "#EC4147" }}>
                                  {formErrors.expiryDate}
                                </span>
                              }
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                              inputProps={{
                                max: "9999-12-31",
                              }}
                              InputLabelProps={{ shrink: true }} // Ensures label doesn't overlap with the selected date
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {(props.insurancetype &&
                          props.insurancetype === "Basic") ||
                        props.insurancetype === "Pre Auth Request" ||
                        props.insurancetype === "Pre Auth Response" ||
                        props.insurancetype === "Claim Request" ||
                        props.insurancetype === "Claim Approval" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="description" className="basicInf">
                              Description
                            </label>
                            <TextField
                              id="desc"
                              value={insuranceDetails.description}
                              placeholder="Add Description.."
                              autoComplete="off"
                              onChange={(event) => {
                                handleInputChange(
                                  "description",
                                  event.target.value
                                );
                              }}
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {(props.insurancetype &&
                          props.insurancetype === "Pre Auth Response") ||
                        props.insurancetype === "InvoiceGen" ||
                        props.insurancetype === "BillClear" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="gender" className="basicInf">
                              {" "}
                              Claim Number{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <TextField
                              id="cnumber"
                              // type="number"
                              value={insuranceDetails.claimNum}
                              placeholder="Claim number"
                              onChange={(event) => {
                                handleInputChange(
                                  "claimNum",
                                  event.target.value
                                );
                              }}
                              error={formErrors.claimNum !== ""}
                              helperText={
                                <span style={{ color: "#EC4147" }}>
                                  {formErrors.claimNum}
                                </span>
                              }
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {(props.insurancetype &&
                          props.insurancetype === "Pre Auth Request") ||
                        props.insurancetype === "Pre Auth Response" ||
                        props.insurancetype === "InvoiceGen" ||
                        props.insurancetype === "Claim Approval" ||
                        props.insurancetype === "Claim Request" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="amount" className="basicInf">
                              Amount <span className="text-danger">*</span>
                            </label>

                            <TextField
                              id="amnt"
                              type="number"
                              value={insuranceDetails.amount}
                              onChange={(event) => {
                                handleInputChange("amount", event.target.value);
                              }}
                              error={formErrors.amount !== ""}
                              helperText={
                                <span style={{ color: "#EC4147" }}>
                                  {formErrors.amount}
                                </span>
                              }
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {/* {(props.insurancetype &&
                          props.insurancetype === "Claim Request") ||
                        props.insurancetype === "BillClear" ? (
                          <Grid item md={6} className="form-group">
                            <label
                              htmlFor="invoice number"
                              className="basicInf"
                            >
                              Invoice Number{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <TextField
                              id="inumber"
                              // type="number"
                              value={insuranceDetails.invoiceNum}
                              onChange={(event) => {
                                handleInputChange(
                                  "invoiceNum",
                                  event.target.value
                                );
                              }}
                              error={formErrors.invoiceNum !== ""}
                              helperText={
                                <span style={{ color: "#EC4147" }}>
                                  {formErrors.invoiceNum}
                                </span>
                              }
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )} */}

                        {props.insurancetype === "Claim Request" && (
                          <>
                            {/* Grid for Unpaid Invoices */}
                            <Grid item md={6} className="form-group">
                              <label
                                htmlFor="invoice number"
                                className="basicInf"
                              >
                                Select Unpaid Invoice(s)
                                <span className="text-danger">*</span>
                              </label>

                              <div
                                className={`p-2 border rounded mt-1 overflow-auto ${
                                  invoiceError ? "border-danger" : ""
                                }`}
                                style={{ maxHeight: "250px" }}
                              >
                                <FormGroup>
                                  {invoiceList?.filter(
                                    (item) => item.receivedAmount === 0
                                  ).length > 0 ? (
                                    invoiceList
                                      .filter(
                                        (item) => item.receivedAmount === 0
                                      )
                                      .map((item, index) => (
                                        <FormControlLabel
                                          key={`unpaid-${index}`}
                                          control={
                                            <Checkbox
                                              size="small"
                                              checked={selectedInvoices?.some(
                                                (inv) =>
                                                  inv.invoiceNum ===
                                                  item.invoiceNum
                                              )}
                                              onChange={(e) =>
                                                handleInvoiceCheckboxChange(
                                                  e.target.checked,
                                                  {
                                                    invoiceNum: item.invoiceNum,
                                                    invoiceDate:
                                                      item.invoiceDate,
                                                  }
                                                )
                                              }
                                            />
                                          }
                                          label={
                                            <span
                                              style={{
                                                fontSize: "14px",
                                              }}
                                            >
                                              #{item.invoiceNum} | Invoice
                                              amount ₹{item.amount} |{" "}
                                              {new Date(
                                                item.invoiceDate
                                              ).toLocaleDateString("en-US", {
                                                year: "numeric",
                                                month: "short",
                                                day: "2-digit",
                                              })}
                                            </span>
                                          }
                                        />
                                      ))
                                  ) : (
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        color: "#999",
                                      }}
                                    >
                                      No unpaid invoices found.
                                    </div>
                                  )}
                                </FormGroup>
                              </div>

                              {invoiceError && (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                  Please select at least one invoice.
                                </div>
                              )}
                            </Grid>

                            {/* Grid for Paid Invoices */}
                            {invoiceList?.some(
                              (item) => item.receivedAmount > 0
                            ) && (
                              <Grid item md={6} className="form-group">
                                <label
                                  htmlFor="invoice number"
                                  className="basicInf"
                                >
                                  Paid Invoice(s)
                                </label>

                                <div
                                  className="p-2 border rounded mt-1 overflow-auto"
                                  style={{ maxHeight: "250px" }}
                                >
                                  <FormGroup>
                                    {invoiceList
                                      .filter((item) => item.receivedAmount > 0)
                                      .map((item, index) => (
                                        <FormControlLabel
                                          key={`unpaid-${index}`}
                                          control={
                                            <Checkbox
                                              size="small"
                                              checked={selectedInvoices.some(
                                                (inv) =>
                                                  inv.invoiceNum ===
                                                  item.invoiceNum
                                              )}
                                              onChange={(e) =>
                                                handleInvoiceCheckboxChange(
                                                  e.target.checked,
                                                  {
                                                    invoiceNum: item.invoiceNum,
                                                    invoiceDate:
                                                      item.invoiceDate,
                                                  }
                                                )
                                              }
                                            />
                                          }
                                          label={
                                            <span
                                              style={{
                                                fontSize: "14px",
                                              }}
                                            >
                                              #{item.invoiceNum} | Invoice
                                              amount ₹{item.amount} | Balance
                                              amount ₹
                                              {item.amount -
                                                item.receivedAmount}{" "}
                                              |{" "}
                                              {new Date(
                                                item.invoiceDate
                                              ).toLocaleDateString("en-US", {
                                                year: "numeric",
                                                month: "short",
                                                day: "2-digit",
                                              })}
                                            </span>
                                          }
                                        />
                                      ))}
                                  </FormGroup>
                                </div>
                              </Grid>
                            )}
                          </>
                        )}

                        {(props.insurancetype &&
                          props.insurancetype === "Pre Auth Response") ||
                        props.insurancetype === "Claim Approval" ? (
                          <Grid item md={12} className="form-group">
                            <p className="mb-2">Status:</p>
                            <RadioGroup
                              row
                              value={selectedRadio}
                              onChange={(event) =>
                                onValueChange(event.target.value)
                              }
                            >
                              <FormControlLabel
                                value="approve"
                                control={<Radio />}
                                label="Approve"
                                checked={selectedRadio === "approve"}
                                onChange={(event) =>
                                  onValueChange(event.target.value)
                                }
                              />
                              <FormControlLabel
                                value="deny"
                                control={<Radio />}
                                label="Deny"
                                checked={selectedRadio === "deny"}
                                onChange={(event) =>
                                  onValueChange(event.target.value)
                                }
                              />
                            </RadioGroup>
                            <div style={{ color: "#EC4147" }}>
                              <span>{formErrors.status}</span>
                            </div>
                          </Grid>
                        ) : (
                          ""
                        )}

                        {props.insurancetype &&
                        (props.insurancetype === "Pre Auth Response" ||
                          props.insurancetype === "Claim Approval") &&
                        insuranceDetails.status === "deny" ? (
                          <Grid item md={6} className="form-group">
                            <label htmlFor="comment" className="basicInf">
                              Comment<span className="text-danger">*</span>
                            </label>
                            <TextField
                              id="comment"
                              value={insuranceDetails.comment}
                              placeholder="Add Comment.."
                              autoComplete="off"
                              onChange={(event) => {
                                handleInputChange(
                                  "comment",
                                  event.target.value
                                );
                              }}
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: { height: "35px" },
                              }}
                              error={formErrors.comment !== ""}
                              helperText={
                                <span style={{ color: "#EC4147" }}>
                                  {formErrors.comment}
                                </span>
                              }
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {props.insurancetype &&
                        props.insurancetype === "BillClear" ? (
                          <Grid item md={12} className="form-group">
                            <p className="mb-2">Status:</p>
                            <RadioGroup
                              className="radioStatus"
                              row
                              value={selectedRadio}
                              onChange={(event) =>
                                onValueChange(event.target.value)
                              }
                            >
                              <FormControlLabel
                                value="failed"
                                control={<Radio />}
                                label="Failed"
                                checked={selectedRadio === "failed"}
                                onChange={(event) =>
                                  onValueChange(event.target.value)
                                }
                              />
                              <FormControlLabel
                                value="noc"
                                control={<Radio />}
                                label="Noc"
                                checked={selectedRadio === "noc"}
                                onChange={(event) =>
                                  onValueChange(event.target.value)
                                }
                              />
                            </RadioGroup>
                          </Grid>
                        ) : (
                          ""
                        )}
                      </>
                    </Grid>
                  </form>

                  {props.insurancetype != "Upload Document" ? (
                    <div className="fbtn mt-4">
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        onClick={(event) => handleSubmit(event)}
                        style={{ textTransform: "none" }}
                      >
                        Save
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                  <br />
                </Grid>
              </Grid>
            </div>
          </div>

          {props.insurancetype === "Upload Document" ? (
            <Components.Attachments
              patientDetail={props.patientInfo}
              InsuranceList={props.insurancelists}
              uploadType={"insurance"}
              openAttachment={(event) => closeAttachment(event)}
            />
          ) : (
            ""
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
export default InsuranceProcedureInput;
